import { Component, OnInit, Renderer2 } from '@angular/core'
import { bxUrl, cxDomain } from '../../common/utilities/constants'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { UserAuthService } from '../../services/user-auth.service'
import { GtmTrackingService } from '../../services/gtm-tracking.service'
import { HeaderComponent } from '../header/header.component'
@Component({
    selector: 'app-exception',
    imports: [RouterModule, HeaderComponent],
    templateUrl: './exception.component.html',
    styleUrl: './exception.component.scss'
})
export class ExceptionComponent implements OnInit {
  cxDomain = cxDomain
  bxHeader: boolean = false
  errorType: string = ''

  constructor (private readonly userAuthService: UserAuthService, private readonly renderer: Renderer2, private route: ActivatedRoute,
    private gtmService: GtmTrackingService) {}
   ngOnInit (): void {
    this.errorType = this.route?.snapshot?.data['type'] || ''
      const referrerUrl = decodeURIComponent(this.userAuthService.getCookie('referrerUrl') || '')
      if (referrerUrl?.includes(bxUrl)) {
        this.bxHeader = true
        this.renderer.addClass(document.body, 'bx-header-enabled')
      } else {
        this.renderer.removeClass(document.body, 'bx-header-enabled')
      }
      this.gtmService.logGaPageview('Server error page')
    }
}
